import { getQuery } from 'utilities/query';

export default class RegulatorService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getDefaultQuery() {
    return {
      ...getQuery(),
      orderBy: 'AgentName',
      direction: 'asc'
    };
  }

  get(id) {
    return this.$http.get(`/api/regulator/${id}`);
  }

  delete(id) {
    return this.$http.delete(`/api/regulator/${id}`);
  }

  add(regulator) {
    return this.$http.post('/api/regulator', regulator);
  }

  update(regulator) {
    return this.$http.put(`/api/regulator/${regulator.RegulatorId}`, regulator);
  }

  search(query) {
    return this.$http.get('/odata/RegulatorOData', {
      params: {
        $select: 'RegulatorId, AgentName',
        $top: query.take,
        $skip: query.calculateSkip(),
        $orderby: `${query.orderBy} ${query.direction}`,
        ...query.filter && { $filter: query.filter.toString() },
        $count: true
      }
    });
  }
}



// WEBPACK FOOTER //
// ./services/regulator.service.js